import {FaviconService} from "../../../favicon/service/FaviconService";

export class HighPriorityNotificationService {

    public static id = "highPriorityNotificationService";

    /** @ngInject */
    public constructor(private readonly faviconService: FaviconService,
                       private readonly growl: Growl) {
    }

    public success(title: string, content: string) {
        this.growl.success(content, {title, ttl: -1});
        this.faviconService.notificationShown();
    }

    public error(title: string, content: string) {
        this.growl.error(content, {title, ttl: -1});
        this.faviconService.notificationShown();
    }
}
